module.exports = __webpack_public_path__ + "img/cszq_partners_4.7fd31889.jpg";